/*
 |--------------------------------------------------------------------------
 | Calamiteitenbanner
 |
 | AveroAchmeaApi.calamiteiten({
 |   styling: 'major', // or 'minor'
 |   icon: 'warning', // or 'lamp'
 |   title: 'Schaatsen uit het vet?',
 |   text: 'Op natuurijs schaatsen zit er waarschijnlijk niet in. Maar het gaat de komende dagen wel vriezen. Wat is handig bij bevriezing en gladheid op de weg?',
 | })
 |--------------------------------------------------------------------------
 */

/* ========================================================================== *\
 IMPORTS
 \* ========================================================================== */

import $ from 'jquery';
import template from 'lodash/template';
import calamiteitenTemplate from './calamiteiten.html';

/* == END IMPORTS =========================================================== */

/* ========================================================================== *\
 CONSTANTS
 \* ========================================================================== */

const /**
   * The module name
   * @type {String}
   */
  moduleName = 'calamiteiten',
  /**
   * Lookup table for selectors
   * @type {Object}
   */
  selectors = {
    portal: `#alerts.alerts`,
  };

/* == END CONSTANTS ========================================================= */

/* ========================================================================== *\
 SETUP EQUALHEIGHT
\* ========================================================================== */

const calamiteiten = (userArguments) => {
  const defaultAgruments = {
    styling: 'major',
    icon: 'warning',
    title: null,
    text: null,
  };

  // the location where the calamiteiten-banner should be displayed
  const portal = document.querySelector(selectors.portal);

  // bail if there's no portal on the page
  if (!portal) {
    return;
  }

  // empty portal, if there's alread a banner set
  portal.innerHTML = '';

  // merge the defaults with the user provided arguments
  const mergedArguments = Object.assign({}, defaultAgruments, userArguments);

  // a banner without title should not be displayed
  if (!mergedArguments.title) {
    throw new Error('Calamiteiten banner needs at least a title');
  }

  // generate a template function
  const compiled = template(calamiteitenTemplate);

  // compile the merged arguments in a result template
  const result = compiled(mergedArguments);

  // create an actual DOM object
  const resultEl = $(result);

  // merge the template in the DOM
  $(portal).append(resultEl);
};

/* ========================================================== */

/* ========================================================================== *\
  EXPORTS
 \* ========================================================================== */

export default calamiteiten;

/* == END EXPORTS ====================================================== */
